import { getApiClient, initializeApiClient } from "../apiService";
export const GetYesNoTableData = async (subTaskFlowGUID) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post("api/YesNo/GetAllYesNoListByTaskGuid", {
    subTaskFlowGUID: subTaskFlowGUID,
  });

  return response;
};
